/* eslint-disable @typescript-eslint/no-explicit-any */
import { setColorTheme } from '@facephi/ui-react';
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  ZoomableGroup,
} from 'react-simple-maps';
import world110m from '../../assets/json/world-110m.json';
import { IMapProps, MarkerDto } from './model';
export const Map = ({ markers = [], testId, width, height }: IMapProps) => {
  return (
    <ComposableMap
      id={testId}
      width={width}
      height={height}
      style={{ width: '100%', height: '100%' }}
    >
      <ZoomableGroup>
        <Geographies geography={world110m} fill={setColorTheme('grey200')}>
          {({ geographies }) =>
            geographies.map((geo: any) => (
              <Geography key={geo.rsmKey} geography={geo} />
            ))
          }
        </Geographies>

        {markers?.map((item: MarkerDto) => (
          <Marker
            coordinates={[item.lng, item.lat]}
            id={item.name}
            key={item.name}
          >
            <circle r={5} fill={setColorTheme('error400')} />
          </Marker>
        ))}
      </ZoomableGroup>
    </ComposableMap>
  );
};
